<template>
  <!-- 应收款明细表 -->
  <div class="ti d-flex">
    <div class="d-flex-right">
      <div class="cdj_div">押金汇总表-查询条件</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">收取日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="startDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="endDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">退还日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="retreatStartDate"
                  type="date"
                  placeholder="开始时间"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="retreatEndDate"
                  type="date"
                  placeholder="结束时间"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">房产范围</div>
              <el-select
                v-model="data.pid"
                multiple
                collapse-tags
                filterable
                style="width: 70%"
                placeholder="选择房产"
              >
                <el-option
                  size="mini"
                  v-for="item in projecta"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <span style="cursor: pointer" @click="completeProject">全选</span>
              <span
                style="margin-left: 3px; cursor: pointer"
                @click="cancelProject"
                >取消</span
              >
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemID"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 50%"
                  placeholder="收费项目"
                >
                  <el-option
                    size="mini"
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel"
                  >取消</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 1px; margin-top: 10px">
        <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="excelPost"
          >导出</el-button
        >
      </div>
    </div>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>
  
  <script>
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "DepositSummarySheet",
  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
    ExcelTask,
  },
  data() {
    return {
      selectList: [],
      project_id: "",
      startDate: "",
      endDate: "",
      retreatStartDate: "",
      retreatEndDate: "",
      chargeitem: [],
      money: "--",
      loading: false,
      desserts: "",
      total: 0,
      page: 12,
      state: 0,
      data: {
        pid: [],
        house_id: "",
        homeName: "",
        startDate: "",
        endDate: "",
        retreatStartDate: "",
        retreatEndDate: "",
        chargeitemID: [],
      },
      excelTask: false,
      excelTaskId: null,
      projecta: [],
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    //押金类型
    this.$myhttp
      .get("admin/common/deposit_type", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    this.projects();
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    //名下项目
    projects() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.projecta = backdata.data.data;
        });
    },
    //导出
    excelPost() {
      this.dates();
      if (!this.data.pid) {
        this.$Message.error("请选择房产");
        return false;
      }
      let data = this.data;
      data.targetController = "Deposits";
      data.targetFunction = "depositSummarySheet";
      data.taskName = "押金汇总表";
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          // this.$store.commit("excelTaskAdd");
          this.$Message.success("导出任务已创建!");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        });
    },
    openExcelTask() {
      // this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.data.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.data.chargeitemID = [];
    },
    //时间转换
    dates() {
      this.data.startDate = "";
      this.data.endDate = "";
      this.data.retreatStartDate = "";
      this.data.retreatEndDate = "";
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = new Date(d).getTime() / 1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate; //开始时间
        let endDate = new Date(d).getTime() / 1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
      if (this.retreatStartDate != null && this.retreatStartDate != "") {
        let d = this.retreatStartDate; //开始时间
        let retreatStartDate = new Date(d).getTime() / 1000;
        retreatStartDate = Number(retreatStartDate).toFixed(0);
        this.data.retreatStartDate = retreatStartDate;
      }
      if (this.retreatEndDate != null && this.retreatEndDate != "") {
        let d = this.retreatEndDate; //开始时间
        let retreatEndDate = new Date(d).getTime() / 1000;
        retreatEndDate = Number(retreatEndDate).toFixed(0);
        this.data.retreatEndDate = retreatEndDate;
      }
    },

    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      //console.log(data.tree)
      this.data.pid = data.tree[0]["id"];
      this.data.homeName = tree_str;
      // this.change(1);
      this.data.house_id = "";
      this.search = tree_str;
      if (data.tree[data.tree.length - 1].type === "room") {
        this.data.house_id = data.tree[data.tree.length - 1].id;
        this.change(1);
      }
    },
    completeProject() {
      let data = this.projecta;
      let ids = [];
      data.map((req) => {
        ids.push(req.id);
      });
      this.data.pid = ids;
    },
    //取消
    cancelProject() {
      this.data.pid = [];
    },
  },
  watch: {},
};
</script>
  <style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Admin/Forms/depositSummarySheet.vue